/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_EsInputs */

const en_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const es_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const de_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const zh_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const ar_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const fr_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const vi_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const sw_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const th_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const bs_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const ja_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const ko_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const pt_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const it_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const sv_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const nl_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const da_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const nb_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const fi_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const pl_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const ru_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const tr_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const hi_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const id_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const ms_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const cs_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const el_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const he_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const af_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const hu_nav_language_es = /** @type {(inputs: Nav_Language_EsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

/**
* | output |
* | --- |
* | "Español" |
*
* @param {Nav_Language_EsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_es = /** @type {((inputs?: Nav_Language_EsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_EsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_es(inputs)
	if (locale === "de") return de_nav_language_es(inputs)
	if (locale === "zh") return zh_nav_language_es(inputs)
	if (locale === "ar") return ar_nav_language_es(inputs)
	if (locale === "fr") return fr_nav_language_es(inputs)
	if (locale === "vi") return vi_nav_language_es(inputs)
	if (locale === "sw") return sw_nav_language_es(inputs)
	if (locale === "th") return th_nav_language_es(inputs)
	if (locale === "bs") return bs_nav_language_es(inputs)
	if (locale === "ja") return ja_nav_language_es(inputs)
	if (locale === "ko") return ko_nav_language_es(inputs)
	if (locale === "pt") return pt_nav_language_es(inputs)
	if (locale === "it") return it_nav_language_es(inputs)
	if (locale === "sv") return sv_nav_language_es(inputs)
	if (locale === "nl") return nl_nav_language_es(inputs)
	if (locale === "da") return da_nav_language_es(inputs)
	if (locale === "nb") return nb_nav_language_es(inputs)
	if (locale === "fi") return fi_nav_language_es(inputs)
	if (locale === "pl") return pl_nav_language_es(inputs)
	if (locale === "ru") return ru_nav_language_es(inputs)
	if (locale === "tr") return tr_nav_language_es(inputs)
	if (locale === "hi") return hi_nav_language_es(inputs)
	if (locale === "id") return id_nav_language_es(inputs)
	if (locale === "ms") return ms_nav_language_es(inputs)
	if (locale === "cs") return cs_nav_language_es(inputs)
	if (locale === "el") return el_nav_language_es(inputs)
	if (locale === "he") return he_nav_language_es(inputs)
	if (locale === "af") return af_nav_language_es(inputs)
	if (locale === "hu") return hu_nav_language_es(inputs)
	return en_nav_language_es(inputs)
});